import { StyledHeader } from "./ClubFinancial";
import LabelText from "../../../ui/LabelText";
import LabelNumber from "../../../styled-components/LabelNumber";
import styled from "styled-components";
import { IClubFinancialOverview, IFinancialChartData } from "../../../types/IClubDetail";
import React, { useEffect, useState } from "react";
import FinancialBarchart from "./FinancialBarchart";
import EmptyDataButton from "../../../ui/EmptyDataButton";

const FinancialCard = styled.div`
  border: 1px solid ${({ theme }) => theme.borderColor};
`;
interface ClubFinancialOverviewProps {
  data: IClubFinancialOverview | undefined;
}

const ClubFinancialOverview: React.FC<ClubFinancialOverviewProps> = ({ data }) => {
  const [financialChartData, setFinancialChartData] = useState<IFinancialChartData[]>([]);

  useEffect(() => {
    setFinancialChartData([
      { name: "Total Revenues", value: data?.totalRevenues, valueText: data?.totalRevenuesText, color: "#4AF075", type: "revenue" },
      { name: "Total costs", value: data?.totalCosts, valueText: data?.totalCostsText, color: "#FF7900", type: "cost" },
      { name: "Net Profit", value: data?.netProfit, valueText: data?.netProfitText, color: "#C9F0B5", type: "profit" },
    ]);
  }, [data]);

  return (
    <>
      <StyledHeader className="header-content">
        <LabelText className="drawer-title">Season overview</LabelText>
        <LabelNumber className="attack-defense-data">
          Updated: {new Date(data != null && data.lastUpdatedDate ? data.lastUpdatedDate : new Date()).toLocaleDateString("en-GB")}
        </LabelNumber>
      </StyledHeader>
      <div className="overview-container">
        <FinancialBarchart data={financialChartData} />

        <div className="financial-card-container">
          <FinancialCard className="financial-stat-card">
            <LabelText className="player-given-name">Earnings before interest & taxes (EBIT)</LabelText>
            {data?.ebitText === null ? (
              <EmptyDataButton label="Data not provided by club" />
            ) : (
              <div>
                <LabelNumber className="squad-number">€</LabelNumber>
                <LabelNumber className="donut-chart-text">{data?.ebitText}</LabelNumber>
              </div>
            )}
          </FinancialCard>
          <FinancialCard className="financial-stat-card">
            <LabelText className="player-given-name">Earnings before taxes (EBT)</LabelText>
            {data?.ebtText === null ? (
              <EmptyDataButton label="Data not provided by club" />
            ) : (
              <div>
                <LabelNumber className="squad-number">€</LabelNumber>
                <LabelNumber className="donut-chart-text">{data?.ebtText}</LabelNumber>
              </div>
            )}
          </FinancialCard>
          <FinancialCard className="financial-stat-card">
            <LabelText className="player-given-name">Taxes</LabelText>
            {data?.taxesText === null ? (
              <EmptyDataButton label="Data not provided by club" />
            ) : (
              <div>
                <LabelNumber className="squad-number">€</LabelNumber>
                <LabelNumber className="donut-chart-text">{data?.taxesText}</LabelNumber>
              </div>
            )}
          </FinancialCard>
        </div>
      </div>
    </>
  );
};

export default ClubFinancialOverview;
